/** Extracts the `src` URL from a raw `<iframe>` HTML snippet (e.g. a Google Maps embed pasted by the merchant). */
export function getIframeSource(iframeContent?: string | null): string | null {
  if (!iframeContent) return null;
  const div = document.createElement("div");
  div.innerHTML = iframeContent;
  const iframe = div.querySelector("iframe");
  return iframe?.getAttribute("src") ?? null;
}
